import { objectValues } from "@ea/shared_components/utils/object";

import variablesEpicsMap from "./variables.epics";
import * as variablesReducers from "./variables.reducers";

const variablesEpics = objectValues(variablesEpicsMap);

export { variablesReducers, variablesEpics };
